import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';

import {
    captionsReducer,
    CAPTIONS_REDUCER_NAME,
} from './captions/captions.slice';
import { FLOWS_REDUCER_NAME, flowsReducer } from './flows/flows.slice';
import { reelsReducer, REELS_REDUCER_NAME } from './reels/reels.slice';
import { usersReducer, USERS_REDUCER_NAME } from './users/users.slice';
import { FLYOVER_REDUCER_NAME, flyoverReducer } from './flyover/flyover.slice';
import {
    FLOW_BUILDER_REDUCER_NAME,
    flowBuilderReducer,
} from './flowBuilder/flowBuilder.slice';
import {
    PERFORMANCE_REDUCER_NAME,
    performanceReducer,
} from './performance/performance.slice';
import {
    ONBOARDING_STEPS_REDUCER_NAME,
    onboardingStepsReducer,
} from './onboardingSteps/onboardingSteps.slice';
import {
    applicationReducer,
    APPLICATION_REDUCER_NAME,
} from './application/application.slice';
import { LIBRARY_REDUCER_NAME, libraryReducer } from './library/library.slice';

export const store = configureStore({
    reducer: {
        [APPLICATION_REDUCER_NAME]: applicationReducer,
        [CAPTIONS_REDUCER_NAME]: captionsReducer,
        [FLOW_BUILDER_REDUCER_NAME]: flowBuilderReducer,
        [FLOWS_REDUCER_NAME]: flowsReducer,
        [REELS_REDUCER_NAME]: reelsReducer,
        [USERS_REDUCER_NAME]: usersReducer,
        [FLYOVER_REDUCER_NAME]: flyoverReducer,
        [PERFORMANCE_REDUCER_NAME]: performanceReducer,
        [LIBRARY_REDUCER_NAME]: libraryReducer,
        [ONBOARDING_STEPS_REDUCER_NAME]: onboardingStepsReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export function useAppSelector<T>(selector: (state: RootState) => T) {
    return useSelector(selector);
}

export function useAppDispatch() {
    return useDispatch<AppDispatch>();
}
